import React from 'react';
import { SignInButton } from './EmailAuth';
import { Star, Lock } from 'lucide-react';
import { UserProfile } from '../services/api';

interface LoginPromptProps {
  onClose: () => void;
  onLogin: (profile: UserProfile) => void;
  tempVisitCount: number;
  tempVisits: Array<{ venueId: number; date: string }>;
}

const LoginPrompt = ({ onClose, onLogin, tempVisitCount, tempVisits }: LoginPromptProps) => {
  const benefits = [
    'Save your visited venues permanently',
    'Track your Michelin star collection',
    'Get personalized recommendations',
    'Share your culinary journey'
  ];

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 animate-in fade-in duration-200">
      <div className="bg-surface rounded-xl shadow-xl max-w-md w-full overflow-hidden">
        <div className="p-6">
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-brand-100 mx-auto mb-6">
            <Lock className="w-8 h-8 text-brand-600" />
          </div>

          <h2 className="font-display font-normal tracking-tight text-2xl text-center mb-2">
            Save Your Progress
          </h2>

          <p className="text-ink-600 text-center mb-6">
            You've marked {tempVisitCount} {tempVisitCount === 1 ? 'venue' : 'venues'} as visited.
            Sign in now to save your progress!
          </p>

          <div className="space-y-3 mb-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center text-ink-700">
                <Star className="w-4 h-4 text-yellow-500 mr-2 flex-shrink-0" />
                <span className="text-sm">{benefit}</span>
              </div>
            ))}
          </div>

          <div className="space-y-3">
            <SignInButton onProfileUpdate={onLogin} onSuccess={onClose} />

            <button
              onClick={onClose}
              className="w-full text-ink-500 hover:text-ink-700 font-medium py-2 px-4 rounded-lg
                       transition-colors duration-200"
            >
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPrompt;
